<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" :categories="productCategories" />
    <div style="width:1366px;">
      <vs-table noDataText="Tabloda Veri Yok" ref="table" pagination :max-items="15" search :data="filteredProducts" maxHeight="60vh" @selected="selectedRow">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse items-center">
            <div class="flex items-center justify-between" style="width: 1000px;">
              <vs-button @click="addNewData" size="small" type="border" class="mr-2 w-1/4">Yeni Ürün Ekle</vs-button>
              <v-select class="w-full mr-2" placeholder="Ürün Kategorisi Seçin" v-model="filters.category" :options="productCategories" :reduce="(productCategories) => productCategories.categoryName" label="categoryName" @input="filterFunc()">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
              <v-select class="w-1/2" placeholder="Ürün Deposu Seçin" v-model="filters.wareHouse" :options="wareHouses" label="value" @input="filterFunc()">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
              <vs-checkbox v-model="filters.showInStock" @input="filterFunc()">Sadece Stoktakiler</vs-checkbox>

              <export-to-excel :printOnExcel="JSON.parse(JSON.stringify(excelDataComputed))" v-if="displayExcel"></export-to-excel>
            </div>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="productId">Ürün Id</vs-th>
          <vs-th sort-key="productName">Ürün Adı</vs-th>
          <vs-th sort-key="productCategory">Kategori</vs-th>
          <vs-th sort-key="productWeight">Ağırlık</vs-th>
          <vs-th sort-key="stock">Stok</vs-th>
          <vs-th sort-key="productType">Tür</vs-th>
          <vs-th sort-key="minPrice">Min Fiyat</vs-th>
          <vs-th sort-key="minPriceCurrencyId">Min Fiyat Döviz Türü</vs-th>
          <vs-th sort-key="owningCost">Maliyet</vs-th>
          <vs-th sort-key="owningCostCurrencyId">Maliyet Döviz Türü</vs-th>
          <vs-th sort-key="salePrice">Satış Fiyatı</vs-th>
          <vs-th sort-key="salePriceCurrencyId">Satış Fiyatı Döviz Türü</vs-th>
          <!-- <vs-th>İşlem</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <tbody ref="tbody">
            <vs-tr :state="tr.totalStock == 0 ? 'danger' : 'success'" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="font-semibold truncate">{{ tr.productId }}</p>
              </vs-td>

              <vs-td>
                <p class="font-semibold truncate">{{ tr.productName }}</p>
              </vs-td>

              <vs-td>
                <p class="product-category putTextCenter">{{ tr.productCategory }}</p>
              </vs-td>

              <vs-td>
                <p class="product-price" style="text-align: center;">{{ tr.productWeight }}</p>
              </vs-td>

              <vs-td v-bind:title="tr.beautifyStockLabel">
                <p class="product-price" style="text-align: center;">{{ selectedWareHouseStock(tr) }}</p>
              </vs-td>
              <vs-td>
                <p class="product-category putTextCenter">{{ tr.productType }}</p>
              </vs-td>
              <vs-td>
                <p class="product-price" style="text-align: center;">{{ tr.minPrice }}</p>
              </vs-td>
              <vs-td>
                <p class="product-price" style="text-align: center;">{{ tr.minPriceCurrencyId }}</p>
              </vs-td>
              <vs-td>
                <p class="product-price" style="text-align: center;">{{ tr.owningCost }}</p>
              </vs-td>
              <vs-td>
                <p class="product-price" style="text-align: center;">{{ tr.owningCostCurrencyId }}</p>
              </vs-td>
              <vs-td>
                <p class="product-price" style="text-align: center;">{{ tr.salePrice }}</p>
              </vs-td>
              <vs-td>
                <p class="product-price" style="text-align: center;">{{ tr.salePriceCurrencyId }}</p>
              </vs-td>

             <!--  <vs-td class="whitespace-no-wrap">
                <feather-icon
                icon="TruckIcon"
                title="Stok Transfer"
                svgClasses="w-6 h-6 hover:text-dark stroke-current"
                class="ml-2 hoverZoom"
                @click.stop="transferItem(tr)"
              />
                <feather-icon icon="EditIcon" title="Ürün Düzenle" class="ml-2 hoverZoom" svgClasses="w-6 h-6 hover:text-dark stroke-current" @click.stop="editData(tr)" />
                <feather-icon icon="TrashIcon" title="Ürün Sil" svgClasses="w-6 h-6 hover:text-dark stroke-current" class="ml-2 hoverZoom" @click.stop="deleteData(tr)" /> 
              </vs-td>-->
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <!-- <transfer-stock
      v-model="productToSent"
      :isTransferActive="transferProduct"
      @closeTransfer="transferProduct = false"
    />-->
    <product-viewer v-model="productToView" :isViewerActive="viewProduct" @closeViewer="viewProduct = false" />
  </div>
</template>

<script>
import ExportToExcel from "../../exportToExcel/exportToExcel.vue";
import { repository } from "@/_services/repository.js";
import DataViewSidebar from "./addEditSidebar.vue";
// import transferStock from "./transferStock.vue";
import productViewer from "./productViewer.vue";

import vSelect from "vue-select";

export default {
  components: {
    DataViewSidebar,
    // transferStock,
    productViewer,
    vSelect,
    ExportToExcel,
  },
  data() {
    return {
      displayExcel: false,
      addNewDataSidebar: false,
      transferProduct: false,
      viewProduct: false,
      sidebarData: {},
      products: [],
      productToSent: [],
      productToView: [],
      productCategories: [],
      wareHouses: [],
      filters: {
        category: null,
        wareHouse: null,
        showInStock: false,
      },
      filteredProducts: [],
      today: new Date().toISOString().substr(0, 10),
      excelFormat: [],
      filteredProductsExcel: [],
    };
  },
  computed: {
    excelDataComputed() {
      return {
        filename:
          this.today +
          " " +
          (this.filters.showInStock ? "Stoğu olan" : "") +
          (this.filters.category ? " " + this.filters.category : " Tüm kategoriler") +
          (this.filters.wareHouse ? " " + this.filters.wareHouse.value : " Tüm depolar") +
          " stok raporu.xlsx",
        table: [...this.excelFormat],
      };
    },
  },
  created: async function() {
    let [a, b, c] = await Promise.all([this.getProducts(), this.getProductCategories(), this.getWareHouses()]);
    if (!a || !b || !c) {
      this.$vs.notify({
        title: "Hata",
        text: "Bağlantı hatası",
        color: "danger",
      });
    }
    this.filterFunc();
    this.filteredProductsExcel = JSON.parse(JSON.stringify(a));
    this.reportFeaturesForExcel();
  },
  methods: {
    reportFeaturesForExcel() {
      let tempData = JSON.parse(JSON.stringify(this.filteredProductsExcel));

      this.excelFormat = [];
      for (let i = 0; i < tempData.length; i++) {
        this.excelFormat.push({
          UrunId: tempData[i].productId,
          UrunAdi: tempData[i].productName,
          Fiyat: tempData[i].price,
          UrunAciklama: tempData[i].productDescription,
          Ağırlık: tempData[i].productWeight,
          ParasutId: tempData[i].parasutId,
          Stoklar: tempData[i].beautifyStockLabel,
          Tip: tempData[i].productType,
          MinFiyat: tempData[i].minPrice,
          MinFiyatDövizTürü: tempData[i].minPriceCurrencyId,
          Maaliyet: tempData[i].owningCost,
          MaaliyetDövizTürü: tempData[i].owningCostCurrencyId,
          SatışFiyatı: tempData[i].salePrice,
          SatışFiyatıDövizTürü: tempData[i].salePriceCurrencyId,
          ToplamStok: tempData[i].totalStock,
        });
      }
      this.displayExcel = true;
    },

    filterFunc() {
      let filtered = [];

      if (!this.filters.showInStock && !this.filters.wareHouse && !this.filters.category) this.filteredProducts = this.products;
      for (let i = 0; i < this.products.length; i++) {
        let p = this.products[i];
        if (this.filters.showInStock) {
          if (this.filters.wareHouse) {
            if (!this.filters.category || p.productCategory == this.filters.category) {
              if (Array.isArray(p.stock))
                for (let j = 0; j < p.stock.length; j++) {
                  if (p.stock[j].stock > 0 && this.filters.wareHouse.id == p.stock[j].wareHouseId) {
                    filtered.push(Object.assign({}, p));
                  }
                }
            }
          } else {
            if (!this.filters.category || p.productCategory == this.filters.category) {
              if (Array.isArray(p.stock) && p.stock.length > 0) {
                filtered.push(Object.assign({}, p));
              }
            }
          }
        } else {
          if (!this.filters.category || p.productCategory == this.filters.category) {
            filtered.push(Object.assign({}, p));
          }
        }
      }

      this.filteredProductsExcel = JSON.parse(JSON.stringify(filtered));
      this.reportFeaturesForExcel();
      this.filteredProducts = filtered;
    },

    selectedWareHouseStock(tr) {
      if (this.filters.wareHouse == null) return tr.totalStock;

      if (tr.stock && tr.stock.length > 0) {
        let a = tr.stock.find((x) => x.wareHouse == this.filters.wareHouse.value);
        return (a && a.stock) || 0;
      } else return "Yok";
    },

    selectedRow(event) {
      //globalFunctions.dataTransporter(event.productId, "ProductCard");
      // this.productToView = event;
      // this.viewProduct = true;

      this.$router.push("../ProductCard/" + event.productId);
    },
    getProducts: async function() {
      this.products = await repository.getAll("Product/getProductsV2").then((r) => {
        if (!r.isSuccessful) {
          this.$vs.notify({
            title: "Hata Ürünler Listesi",
            text: `${this.products.exceptionMessage}`,
            color: "danger",
            icon: "warning",
          });
        } else return r.list;
      });

      this.products = repository.convertToJSON(this.products, "stock");
      try {
        for (let i = 0; i < this.products.length; i++) {
          let x = this.products[i];
          if (x.stock && x.stock.length > 0) {
            let sum = 0;
            let text = "";

            for (let j = 0; j < x.stock.length; j++) {
              sum += x.stock[j].stock;
              text += x.stock[j].stock + " Adet " + x.stock[j].wareHouse + "\n";
            }

            x.totalStock = sum;

            x.beautifyStockLabel = text;
          } else x.totalStock = "Yok";
        }
      } catch (e) {
        console.warn(e);
      }

      return this.products;
    },
    getProductCategories: async function() {
      let tmpCat = await repository.getAll("Product/getProductCategories").then((r) => {
        if (!r.isSuccessful) {
          this.$vs.notify({
            title: "Hata Ürün Kategorileri",
            text: `${this.products.exceptionMessage}`,
            color: "danger",
            icon: "warning",
          });
          return null;
        }
        return r.list;
      });
      this.productCategories = [];
      for (let i = 0; i < tmpCat.length; i++) {
        this.productCategories.push({
          categoryId: tmpCat[i].categoryId,
          categoryName: tmpCat[i].categoryName,
        });
      }
      return this.productCategories;
    },

    getWareHouses: async function() {
      this.wareHouses = await repository.getAll("Inventory/getWarehouses").then((r) => {
        if (!r.isSuccessful) {
          this.$vs.notify({
            title: "Hata Ürün Depoları",
            text: `${this.products.exceptionMessage}`,
            color: "danger",
            icon: "warning",
          });
        } else return r.list;
      });
      return this.wareHouses;
    },

    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData: async function(tr) {
      let p = confirm("Silmek istediğinize emin misiniz?");
      if (p) {
        let r = await repository.postEntity("product/delete/" + tr.productId);
        if (r && !r.hasExceptionMessage) {
          this.$vs.notify({
            title: "Silindi",
            text: "Ürün silindi",
            color: "warning",
            icon: "warning",
          });
        } else {
          this.$vs.notify({
            title: "Hata",
            text: (r && r.exceptionMessage) || "Bilinmeyen hata!",
            color: "danger",
            icon: "warning",
          });
        }
        return;
      }
    },
    editData: async function(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getProduct: async function(data) {},
    toggleDataSidebar(val = false) {
      if (val === false) {
        this.getProducts();
      }
      this.addNewDataSidebar = val;
    },
    // transferItem(data) {
    //   if (data.totalStock == "Yok") {
    //     this.$vs.notify({
    //       title: "Uyarı",
    //       text: "Stok olmayan ürünü, transfer edemezsiniz.",
    //       color: "warning",
    //       icon: "warning",
    //     });
    //     return;
    //   }
    //   this.productToSent = data;
    //   this.transferProduct = true;
    // },
  },
};
</script>

<style lang="scss" scoped>
.hoverZoom :hover {
  -ms-transform: scale(1.2); /* IE 9 */
  -webkit-transform: scale(1.2); /* Safari 3-8 */
  transform: scale(1.2);
  cursor: pointer;
}
#data-list-thumb-view {
  .vs-table--tbody-table .tr-values td {
    padding: 0px !important;
  }
  .vs-con-table {
    .vs-table--tbody {
      max-height: 65vh;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.5rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          &:first-child {
            border-top-left-radius: 0.2rem;
            border-bottom-left-radius: 0.2rem;
          }
          &:last-child {
            border-top-right-radius: 0.2rem;
            border-bottom-right-radius: 0.2rem;
          }
          &.img-container {
            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 45px;
            }
          }
        }
        td.td-check {
          padding: 5px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 400;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
@media only screen and (max-width: 650px) {
  body {
    overflow: scroll !important;
  }
}
</style>
